// Utility function to load all images from the projims folder
const importAll = (requireContext) => {
    const images = {};
    requireContext.keys().forEach((key) => {
        // Strip the file path and extension to create a usable key
        const imageName = key.replace('./', '').replace(/\.[^/.]+$/, '');
        images[imageName] = requireContext(key);
    });
    return images;
};

// Import all images from the projims folder
const images = importAll(require.context('./projims', false, /\.(png|jpe?g|svg)$/));

const texts = {
    mileCalc: {
        title: "MileCalc",
        body: "A personal web development project designed to automate weekly run planning.",
        link: "https://milecalc.harrylons.com",
        github: "https://github.com/harry-lons/MileCalc",
        imgs: [images['mc-2'], images['mc-1']]
    },
    betterGraphs: {
        title: "BetterGraphs",
        body: "",
        link: "",
        github: "",
    },
    hardHack: {
        title: "UCSD HardHack 2024",
        body: "I competed in a team of 3 at the \"UCSD HardHack\" (Hardware Hackathon) 2024, where we engineered a small wayfinding device powered by Arduino microcontroller and LCD display to direct the user home in the dark. We solved some challenging problems along the way to achieving first place in track C, outperforming 7 competitor teams",
        link: "https://docs.google.com/document/d/1S8pRMNw4NopTEcnJ9fmm_FyapqLK-i67Nd-qQjScwKQ/edit",
        github: "https://github.com/harry-lons/HardHack2024?tab=readme-ov-file",
        imgs: [images['hh-1'], images['hh-2'], images['hh-3']]
    },
    projE: {
        title: "Project Euler",
        body: "Project Euler is a site presenting a set of mathematical programming problems. It is permitted to share the solutions to the first 100 problems, and no more. I've solved a few of the first 100, and stored my solutions in a GitHub repo.",
        link: "https://projecteuler.net",
        github: "https://github.com/harry-lons/PROJECT-EULER",
    },
    TR: {
        title: "Triton Robotics",
        body: "I am a member of Triton Robotics, a competitive robotics team based at UCSD which competes in the annual RoboMaster North America (RMNA) challenge. In my role on the autonomy team, I am working on the targeting and decision-making algorithms for the robots.",
        link: "https://tritonrobotics.ucsd.edu/",
        github: "https://github.com/Triton-Robotics",
    },
    Syn2fp: {
        title: "Synthesis 2 Final Project",
        body: "As a final project for my sophomore-year writing class, we wrote a proposal for a website which increases political accessibility in historically disenfranchised/disadvantaged communities. I created a demo React site to display what such a website could look like",
        github: "https://github.com/harry-lons/SYN-2-Project-3",
        imgs: [images['syn2-1'], images['syn2-2']]
    },
    CW: {
        title: "Internship at CurbWaste",
        link: "https://curbwaste.com",
        body: "As an Engineering intern at CurbWaste, I had the opportunity to experience working in industry alongside a great team of developers. The main two focuses of my time at the company were: 1) creation of internal dashboards and data collection for said dashboards, and 2) improving our E-Commerce platform for our subscribers."
    },
    RunSum: {
        title: "RunSum",
        link: "https://runsum.harrylons.com",
        github: "https://github.com/harrylons-runsum/",
        body: "RunSum is a site designed to provide retrospective training insights for endurance athletes. Inspired by Spotify Wrapped and similar products, RunSum allows Strava users to sign in with their Strava accounts, define a time range they're interested in, and attain some summary statistics and metrics on their workouts during that period."
    },
    CSE110: {
        title: "CSE 110 (Software Engineering) Group Project",
        link: "https://youtu.be/ZsWwgNoCHX8",
        github: "https://github.com/harry-lons/socalsocial",
        body: "In the Fall 2024 quarter, I took CSE 110, a project-based software engineering course. I led a group of 7 to complete a functional full-stack webapp within about 6 weeks. Our project was SoCalSocial, a site for clubs on college campuses to market their events on a unified platform. Above is the youtube video of the live demo to ~100 people on the last day of class. Team members: Ali Alabiad, Allen Yan, Allison Nguyen, Shengqi (Diana) Wu, George Pong, Harry Lonsdale, Vivian Wang"
    },
    LabStream: {
        title: "JSOE LabStream Project",
        github: "https://github.com/UCSD-LabStream",
        body: "I'm collaborating with Professor Baghdadchi’s LabStream project in the ECE department to create a responsive React frontend enabling UCSD students to complete photonics lab experiments remotely. As part of a team of 7 students, we are integrating real-time control of 3D models on a web interface with lab equipment using HTTP requests to ESP32 microcontrollers, bridging digital simulations with physical lab components"
    }
}

export default texts;